import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetPayrollRunEmployeesRequest,
  TGetPayrollRunEmployeesResponse,
} from "./getPayrollRunEmployees.schema";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const getPayrollRunEmployees = (axios: IAxiosInstance) => {
  return async (params: TGetPayrollRunEmployeesRequest) => {
    const { payroll_run_id, ...rest } = params;

    const response = await axios.noRetry.get<
      IApiResponse<Array<TGetPayrollRunEmployeesResponse>>
    >(`/api/payroll-runs/${payroll_run_id}/employees`, {
      params: rest,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
